import createReadonlyDictionary from "stores/templates/ReadonlyDictionaryStore";

import api from "services/api";

const FoodMealTypeDictionary = createReadonlyDictionary({
  fetch: async function() {
    return await api.get(`/food/meal/type/list`);
  },
});

export default FoodMealTypeDictionary.create();
